'use client';

import { css } from '@linaria/core';

export const root = css`
  display: flex;
  height: 100%;
  overflow: hidden;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const background = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  font-size: 30vw;
  color: rgba(0, 0, 0, 0.02);
  line-height: 1em;
  z-index: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: space-between;
  font-weight: 800;
  transform: rotate(30deg);
  :last-child {
    align-self: flex-end;
  }
`;

export const card = css`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  max-width: 75%;
  padding: 3rem;
`;
